export default {
  auth: {
    SET_TOKEN: 'setToken',
  },
  applicant: {
    SET_CATEGORIES: 'setCategories',
    SET_EVENTS: 'setEvents',
    SET_APPLICANTS: 'setApplicants',
    SET_PROFILE: 'setProfile',
    SET_ACTIVE_CATEGORY: 'setActiveCategory',
    TOGGLE_FAVORITES: 'toggleFavorites',
    TOGGLE_INTERVIEWS: 'toggleInterviews',
    TOGGLE_SEARCH_MODAL: 'toggleSearchModal',
    TOGGLE_SCOUT: 'toggleScout',
    TOGGLE_SEARCH_EDIT_MODAL: 'toggleSearchEditModal',
    TOGGLE_FILTER_MODAL: 'toggleFilterModal',
    CHANGE_SEARCH_PARAMS: 'changeSearchParams',
    SET_SELECTORS: 'setSelectors',
    CHANGE_SORT_COLUMN: 'changeSortColumn',
  },
};
